import { useMemo } from 'react';

import { decodeAvatar, isAvatarCode, isPhotoAvatar, photoUrl } from '@shared/avatar';
import { AvatarFigure } from '@/features/avatar/AvatarFigure';

/**
 * El avatar de un jugador tal y como llega del servidor: un emoji, el código
 * de un busto personalizado o una foto. El busto y la foto miden lo mismo que
 * el texto que los rodea (1.25em), así que encajan en los mismos huecos que
 * el emoji.
 */
export function Avatar({ value, className = 'inline-block size-[1.25em] align-middle' }: { value: string | null | undefined; className?: string }) {
  const look = useMemo(() => (isAvatarCode(value) ? decodeAvatar(value) : null), [value]);
  if (isPhotoAvatar(value)) {
    return <img src={photoUrl(value)} alt="" loading="lazy" decoding="async" draggable={false} className={`${className} rounded-full object-cover`} />;
  }
  if (!look) return <>{value || '♟️'}</>;
  return <AvatarFigure look={look} className={className} />;
}
